export default "/_next/static/chunks/fonts/Raleway Bold-8e546283422c830c02dca16665043d9e.ttf";